import './carousel.styles.scss';

import * as React from 'react';
import { Carousel as OriginalCarousel } from "antd";
import { CarouselProps as OriginalCarouselProps } from 'antd/es/carousel';
import { omitProps } from '../../utilities';

/**
 * Carousel Props
 *
 * @memberof Carousel
 */
interface CarouselProps extends OriginalCarouselProps {
    /**
     * A React element to serve as the next arrow.
     */
    nextArrow: JSX.Element | undefined;
    /**
     * A React element to serve as the previous arrow.
     */
    prevArrow: JSX.Element | undefined;
    /**
     * Styles for the next arrow button (if props.arrows === true)
     */
    nextArrowStyle: React.CSSProperties;
    /**
     * Styles for the previous arrow button (if props.arrows === true)
     */
    prevArrowStyle: React.CSSProperties;
}

function DefaultPrevArrow(props: any) {
    const { className, style, onClick, prevArrowStyle } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                color: "white",
                display: "block",
                left: "0rem",
                textAlign: "center",
                position: "absolute",
                zIndex: 1,
                ...prevArrowStyle
            }}
            onClick={onClick}
        >
            <svg width={'50%'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.27 18.73">
                <polygon fill="#fff" points="9.07 0 0 9.29 9.07 18.73 11.2 16.61 4.54 9.22 11.27 2.12 9.07 0" />
            </svg>
        </div>
    );
}

function DefaultNextArrow(props: any) {
    const { className, style, onClick, nextArrowStyle } = props;
    return (
        <div
            className={className}
            style={{
                ...style,
                color: "white",
                display: "block",
                right: "0rem",
                textAlign: "center",
                ...nextArrowStyle
            }}
            onClick={onClick}
        >
            <svg width={'50%'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.27 18.73">
                <polygon fill="#fff" points="2.19 18.73 11.27 9.44 2.19 0 0.07 2.12 6.73 9.51 0 16.61 2.19 18.73" />
            </svg>
        </div>
    );
}

/**
 * The Carousel component.
 */
class Carousel extends React.Component<CarouselProps> {
    /**
     * Default properties
     */
    static defaultProps: CarouselProps = {
        dots: false,
        arrows: true,
        nextArrow: undefined,
        prevArrow: undefined,
        nextArrowStyle: {},
        prevArrowStyle: {}
    };

    getPrevArrow() {
        const { arrows, prevArrowStyle } = this.props;
        return (arrows) ? <DefaultPrevArrow prevArrowStyle={prevArrowStyle} /> : undefined;
    }

    getNextArrow() {
        const { arrows, nextArrowStyle } = this.props;
        return (arrows) ? <DefaultNextArrow nextArrowStyle={nextArrowStyle} /> : undefined;
    }

    render() {
        const propsToPassDown = { ...omitProps(this.props, []) };
        /**
         * If we're using arrows instead of dots, we need to add the arrows here
         */
        const arrowButtons = {
            nextArrow: this.getNextArrow(),
            prevArrow: this.getPrevArrow()
        };
        return (
            <div className="carousel">
                <OriginalCarousel
                    {
                    ...propsToPassDown
                    }
                    {
                    ...arrowButtons
                    }
                />
            </div>
        );
    }
}

export { Carousel };
